import styled from 'styled-components';

export const Container = styled.div`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
`;

export const SimpleRow = styled.div`
  display: flex;
  align-items: center;
`;

export const SpacedRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Status = styled.div`
  font-size: 0.8rem;
  color: #777;
`;

export const ReportName = styled.div`
  font-size: 1rem;
  font-weight: bold;
`;

export const Result = styled.div`
  font-size: 0.8rem;
  color: #007bff;
`;